






















































































































































import {Component, Mixins, Watch} from 'vue-property-decorator';
import WidgetDataTimerMixin from '@/mixins/WidgetDataTimerMixin';
import {httpClient} from '@/api/baseApi';
import Loading from '@c/controls/Loading.vue';
import SimpleDialog from '@c/SimpleDialog.vue';
import {pmoduleDataRoutesByTypeMap} from '@v/system/modules/configurate';
import {EventName} from './enums';
import {
  getErrorOccurredMessage,
  getDeviceChangedMessage,
  getBoundaryPassedMessage,
} from './ProblemLogMessages';
import userSettingsStoreModule from '@/store/modules/userSettingsModule';
import {getDaysCountText} from '@u/getDaysCountText';
import {pmonitorTypes} from '@/views/system/modules/configurate';
import {moduleTypeToIdMap} from '@/store/modules/enumsModule';

@Component({
  components: {
    Loading,
    SimpleDialog,
  },
})
export default class DashboardView extends Mixins(WidgetDataTimerMixin) {
  daysCountModel: any = null;
  daysCountDaysTitle = '';
  recordsCountModel: any = null;
  dataStreamModel: any = null;
  eventTypeModel: string | null = null;
  dataStreamModelTitle = '';
  eventTypeModelTitle = '';
  hideZeroLevelModel = false;

  daysCount: any = [];
  recordsCount: any = [];
  dataStream: any = [];
  eventTypes: {value: string; description: string}[] = [
    {
      value: 'boundary_passed',
      description: 'Только границы',
    },
    {
      value: 'device_changed',
      description: 'Только устройства',
    },
    {
      value: 'error_occurred',
      description: 'Только ошибки',
    },
  ];

  data: any = [];

  loading = false;
  error = false;

  dialog = false;
  protected getDataTimeout = 300;

  @Watch('daysCountModel')
  async onDaysCountModel(value: number) {
    if (value) this.daysCountDaysTitle = getDaysCountText(value);
  }

  @Watch('dataStreamModel')
  async onDataStreamModel(val: string) {
    this.dataStreamModelTitle = this.getDataStreamModelTitle(val);
  }

  @Watch('eventTypeModel')
  async onEventTypeModel(val: string) {
    this.eventTypeModelTitle = this.getEventTypeModelTitle(val);
  }

  async created() {
    const settings = await userSettingsStoreModule.getLogSettings();
    if (settings) {
      this.hideZeroLevelModel = settings.hideZeroLevelModel;
      this.eventTypeModel = settings.eventType;
    }

    this.setDaysFilter(settings ? settings.daysCount : null);
    this.setRecordsFilter(settings ? settings.recordsCount : undefined);
    await this.setStreamFilter(settings ? settings.dataStream : null);
    this.refresh(async () => {
      await this.getData();
    });
  }

  reload() {
    this.getData();
  }

  setDaysFilter(value: any) {
    for (let i = 1; i <= 15; i++)
      this.daysCount.push({
        value: i,
        description:
          i == 1
            ? 'Последний день'
            : i == 2 || i == 3 || i == 4
            ? 'Последние ' + i + ' дня'
            : 'Последние ' + i + ' дней',
      });
    this.daysCountModel = value ? value : 7;
  }

  setRecordsFilter(value: any) {
    for (let i = 10; i <= 150; i += 10)
      this.recordsCount.push({
        value: i,
        description: 'Последние ' + i + ' записей',
      });
    this.recordsCountModel = value !== undefined ? value : 20;
  }

  getDataStreamModelTitle(value: string): string {
    return this.dataStream.find((item: any) => item.type === value)?.description ?? '';
  }

  getEventTypeModelTitle(value: string): string {
    return this.eventTypes.find((item: any) => item.value === value)?.description ?? '';
  }

  async setStreamFilter(value: any) {
    const {data} = await httpClient.get<[]>(`module_types/`);
    this.dataStream = data
      .map((x: any) => {
        return {
          value: x.value,
          description: x.description,
          type: x.value,
        };
      })
      .concat(pmonitorTypes);
    this.dataStreamModel = value;
  }

  async getModules(guids: any) {
    const {data} = await httpClient.get(`modules/`, {params: {guids: JSON.stringify(guids)}});
    return data;
  }

  async getTasks() {
    const {data} = await httpClient.get(`heater-monitor-modules/tasks/`);
    return data;
  }

  async getTrends() {
    const {data} = await httpClient.get(`signal-trend-tasks/`);
    return data;
  }

  async getData() {
    try {
      this.loading = true;

      const now = new Date();
      const today = Math.ceil(now.getTime() / 86400000) * 86400000;
      const startDate = today - this.daysCountModel * 24 * 60 * 60 * 1000 - 3 * 60 * 60;

      const params: any = {};
      params.start_date = startDate;
      if (this.recordsCountModel) params.limit = this.recordsCountModel;
      if (this.dataStreamModel) params.module_type = this.dataStreamModel;
      if (this.eventTypeModel) params.event_type = this.eventTypeModel;
      if (this.hideZeroLevelModel) params.min_level = 1;

      const {data} = await httpClient.get<[]>(`logs/common`, {params: params});
      let index = 0;
      const guids = (data as any)[0].map((x: any) => x[1]);
      const modulesData = await this.getModules(Array.from(new Set(guids)));
      const tasksData = await this.getTasks();
      const trendData = await this.getTrends();
      const allModulesTasks = tasksData.concat(modulesData).concat(trendData);

      const records = [];
      for (const element of (data as any)[0]) {
        try {
          const moduleData = (allModulesTasks as any).find((t: any) => t.guid == element[1]);
          //        if (!moduleData) continue;
          const date = new Date(element[0]);
          index += 1;
          const content_data = JSON.parse(element[6]);
          const m = moduleData?.type
            ? this.dataStream.find((t: any) => t.type == moduleData?.type)
            : null;
          records.push({
            index: index,
            timestamp: element[0],
            date: date ? date.toLocaleString() : '',
            eventName: element[3],
            level: element[4],
            code: element[5],
            content: content_data,
            moduleId: moduleData?.id ? moduleData?.id : element[1],
            moduleName: moduleData?.name ? moduleData?.name : element[1],
            module: m ? m.value : element[2],
            showFullMessage: false,
          });
        } catch (e1) {
          console.log('error parsing log entry:', e1);
        }
      }
      this.data = records.sort((x: any, y: any) => x.timestamp - y.timestamp).reverse();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  async applySettings() {
    await this.getData();
    const settings = {
      daysCount: this.daysCountModel,
      recordsCount: this.recordsCountModel,
      dataStream: this.dataStreamModel,
      dataStreamModelTitle: this.dataStreamModelTitle,
      eventTypeModelTitle: this.eventTypeModelTitle,
      eventType: this.eventTypeModel,
      hideZeroLevelModel: this.hideZeroLevelModel,
    };
    userSettingsStoreModule.setProblemLogSettings(settings);
  }

  getLevelColor(level: any) {
    if (level == 0) return 'green';
    else if (level == 1) return 'yellow';
    else if (level == 2) return 'orange';
    else if (level == 3) return 'red';
    else return '';
  }

  getMessage(item: any) {
    switch (item.eventName) {
      case EventName.DeviceChanged:
        return getDeviceChangedMessage(item);
      case EventName.ErrorOccurred:
        return getErrorOccurredMessage(item);
      case EventName.BoundaryPassed:
        return getBoundaryPassedMessage(item);
      default:
        return item.eventName;
    }
  }

  async openModuleView(item: any) {
    const name = pmoduleDataRoutesByTypeMap.get(item.module);
    const {href} = this.$router.resolve({
      name: name ? name : pmoduleDataRoutesByTypeMap.get(moduleTypeToIdMap[item.module]),
      params: {id: `${item.moduleId}`},
    });
    window.open(href, '_blank');
  }
}
